// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"a0d5ffccc5602b334325","883":"226c41863fb39c4d32f2"}[chunkId] + ".js";
};